export default __webpack_public_path__ + "static/media/close.3fb66b18.svg";